/** Zone de texte qui grandit avec son contenu (1 ligne au départ, pas de barre de défilement). */
import { useLayoutEffect, useRef } from "react";

export default function AutoTextarea({ value, onChange, className = "", minRows = 1, ...rest }) {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const fit = () => {
      el.style.height = "";
      if (el.value) el.style.height = `${el.scrollHeight}px`;
    };
    fit();
    let w = el.clientWidth;
    const ro = typeof window !== "undefined" && window.ResizeObserver ? new window.ResizeObserver(() => { if (el.clientWidth !== w) { w = el.clientWidth; fit(); } }) : null;
    ro?.observe(el);
    return () => ro?.disconnect();
  }, [value]);
  return <textarea ref={ref} rows={minRows} value={value} onChange={onChange} className={`${className} resize-none overflow-hidden leading-snug`} {...rest} />;
}
